export default __webpack_public_path__ + "static/media/logo.ccc70a9c.svg";